import React from 'react'
import { Modal, Box, CircularProgress, Typography } from '@mui/material'
import { brown } from '@mui/material/colors'
import { ReactComponent as LocationSVG } from '../../assets/images/location.svg'
import { useTheme } from '@mui/material/styles'

const modalStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
}

const boxStyle = {
  backgroundColor: 'white',
  borderRadius: '12px',
  padding: '25px 20px',
  textAlign: 'center',
  width: '300px',
  boxShadow: 6,
  position: 'relative',
}

const svgContainer = {
  position: 'relative',
  width: '100px',
  height: '100px',
  margin: '0 auto 12px auto',
}

const LoadingModal = ({ open }) => {
  const theme = useTheme()

  const loadingTextStyle = {
    marginTop: '18px',
    fontSize: '1.2em',
    fontWeight: 600,
    color: brown[800],
    fontFamily: theme.typography.fontFamily,
  }
  const circularProgressStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
    color: theme.palette.primary.main,
  }
  return (
    <Modal open={open} sx={modalStyle}>
      <Box sx={boxStyle}>
        <Box sx={svgContainer}>
          <Box position="relative" top={15}>
            <LocationSVG width={75} height={75} />
          </Box>
          <CircularProgress size={100} sx={circularProgressStyle} thickness={2} />
        </Box>
        <Typography sx={loadingTextStyle}>Cargando arbolado...</Typography>
      </Box>
    </Modal>
  )
}

export default LoadingModal
